import { styled } from "@vitality-ds/system";
import BaseTextCellStyles from "./styles/BaseTextCell.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseTextCell = styled("div", BaseTextCellStyles);